import { ILookupItemModel, ITransactionFormData } from "./types";

export interface ITransactionModel extends ITransactionFormData {
  id: number;
}

export interface SubscriptionPlan {
  id: string;
  name: string;
  description: string;
  images: string[];
  prices: {
    id: string;
    unitAmount: number;
    currency: string;
    recurring?: {
      interval: string;
      interval_count: number;
    };
  }[];
  metadata?: {
    features: string;
  };
}

export enum OperationStatus {
  Pending = "Pending",
  Completed = "Completed",
  Failed = "Failed",
}

export interface ITransactionUploadSummary {
  isComplete: boolean;
  errors: string[];
  totalProcessed: number;
  totalInserted: number;
  totalDuplicates: number;
  totalUpdated: number;
  // PropMix stats - simplified
  propMixLookupsSuccess?: number;
  propMixLookupsFailed?: number;
  propMixEnabled?: boolean;
  batchId?: string;
  // Import failure statistics
  validationFailures?: number;
  geocodingFailures?: number;
}

export interface ITransactionUploadProgress {
  processedCount: number;
  duplicateCount: number;
  insertedCount: number;
}

export interface IFinancialCategoryDataSummaryModel {
  totalCount?: number;
  totalAmount?: number;
  yearId?: number | undefined;
  month?: number | undefined;
  quarter?: number | undefined;
}

export type DecodedToken = {
  roles?: string[];
  [key: string]: any;
};
